import React from 'react';
import { connect } from 'react-redux';
import { DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ROMShoulderFunctionalIR extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='ROM - Shoulder Functional IR' />
                <label className={styles.textarea_label}>Shoulder Functional IR</label>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTIRAROMR'
                    className={styles.arom_r}
                />
                <span className={styles.arom_c} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevAromR}
                    </span>
                </span>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTIRAROML'
                    className={styles.arom_l}
                />
                <span className={styles.arom_arom_spacer} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevAromL}
                    </span>
                </span>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTIRPROMR'
                    className={styles.prom_r}
                />
                <span className={styles.prom_c} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevPromR}
                    </span>
                </span>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTIRPROML'
                    className={styles.prom_l}
                />
                <span className={styles.prev_wrapper}>
                    {this.props.prevPromL}
                </span>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));

    let prevPromR = '';
    let prevPromL = '';
    let prevAromR = '';
    let prevAromL = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVEROMPREV[pk]) {
        prevPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTIRPROMR'];
        prevPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTIRPROML'];
        prevAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTIRAROMR'];
        prevAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTIRAROML'];
    }


    return {
        noteId: noteId,
        rono: rono,
        flagged: state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTIRPROMR ||
            state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTIRPROML ||
            state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTIRAROMR ||
            state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTIRAROML
            ? true : false,
        prevPromR,
        prevPromL,
        prevAromR,
        prevAromL,
    };
}

const connectedROMShoulderFunctionalIR = connect(mapStateToProps)(ROMShoulderFunctionalIR);
export { connectedROMShoulderFunctionalIR as ROMShoulderFunctionalIR };


